import Circle from '@uiw/react-color-circle';
import { Popover } from 'antd';
import { FC } from 'react';

interface ColorPickerProps {
  colors?: string[] | undefined;
  color: string;
  onChange: (color: string) => void;
}

export const ColorPicker: FC<ColorPickerProps> = (props) => {
  const { color, onChange, colors } = props;

  const blStyles = Object.assign({
    width: '50px',
    height: '20px',
    border: '2px solid #fff',
    boxShadow: '0 0 0 1px #ccc',
    borderRadius: '10px',
    backgroundColor: color,
  });

  return (
    <Popover
      trigger="click"
      content={
        <Circle
          color={color}
          onChange={(color) => {
            onChange(color.hex);
          }}
          colors={colors}
        />
      }
    >
      <div style={blStyles} />
    </Popover>
  );
};
